import React, { useEffect, useState } from 'react';
import { Home, Bath, Car, Users, Bed } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const VacancyListing = () => {
      const navigate = useNavigate();
  const [vacancies, setVacancies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleHomeClick = (homeId) => {
    navigate(`/ViewHome/${homeId}`);
  };

  const getImageUrl = (homeId, filename) => {
    return `${BASE_URL}/api/homes/${homeId}/images/${filename}`;
  };

  useEffect(() => {
    fetch(BASE_URL+'/api/top-homes')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch properties');
        }
        return response.json();
      })
      .then((data) => {
        setVacancies(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="text-center text-primary">Loading properties...</p>;
  if (error) return <p className="text-center text-red-500">Error: {error}</p>;

return (
    <div className="bg-purple-100 p-8">
        <div className="max-w-6xl mx-auto">
            <h1 className="text-5xl font-arial-rounded font-bold text-primary text-center mb-4">
                Current Vacancies
            </h1>
            <p className="text-xl text-primary text-center mb-8">
                Check out our open houses or contact us to organise a property visit
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {vacancies.map((home) => (
                    <div 
                                  key={home.id} 
                                  className="bg-white rounded-xl border-primary border-2 overflow-hidden shadow-lg cursor-pointer hover:shadow-xl transition-shadow"
                                  onClick={() => handleHomeClick(home.id)}
                                >
                                  {/* Property Image */}
                                  <div className="relative">
                                    <div className="absolute top-4 left-4 bg-white px-3 py-1 rounded-md">
                                      <span className="font-semibold">{home.area}, {home.state}</span>
                                    </div>
                                    {home.images?.length > 0 && (
                                      <img
                                        src={getImageUrl(home.id, home.images[0])}
                                        alt={home.propertyName}
                                        className="w-full h-48 object-cover"
                                      />
                                    )}
                                  </div>
                    
                                  <div className="p-6">
                                    {/* Property Name and Building */}
                                    <div className="mb-4">
                                      <h3 className="text-xl font-bold text-primary">{home.propertyName}</h3>
                                      {home.building && <p className="text-gray-600">{home.building}</p>}
                                    </div>
                    
                                    {/* Property Features */}
                                    <div className="flex justify-between items-center mb-4">
                                      <div className="flex items-center gap-4">
                                        <div className="flex items-center gap-1">
                                          <Bed size={16} />
                                          <span>{home.bedrooms} + {home.guestRooms}</span>
                                        </div>
                                        <div className="flex items-center gap-1">
                                          <Bath size={16} />
                                          <span>{home.bathrooms}</span>
                                        </div>
                                        <div className="flex items-center gap-1">
                                          <Car size={16} />
                                          <span>{home.garage}</span>
                                        </div>
                                      </div>
                                    </div>
                    
                    
                    
                                    
                    
                                    {/* SDA Info */}
                                    <div className="mb-4">
                                      <p className="font-semibold text-primary">
                                        {home.isRegisteredSda ? 'Registered SDA Property' : 'Non-SDA Property'}
                                      </p>
                                      {home.sdaCategory && (
                                        <p className="text-gray-700">SDA Category: {home.sdaCategory}</p>
                                      )}
                                      {home.price && (
                                        <p className="text-gray-700">Rent: {home.price}%</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                ))}
            </div>

            <div className="text-center mt-8 space-y-4">
                <button 
                    onClick={() => window.location.href = '/properties'}
                    className="bg-primary text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-primary transition-colors"
                >
                    See More
                </button>
                <div>
                    <a href="#" className="text-purple-900 underline">
                        Click to download information packet
                    </a>
                </div>
            </div>
        </div>
    </div>
);
};

export default VacancyListing;
